import {
  AlarmClient,
  CableClient,
  ConfigurationClient,
  DasClient,
  DoBClient,
  DocumentationClient,
  DtsClient,
  HomeClient,
  OrganizationClient,
  ProjectClient,
  RttrClient,
  SparePartsClient,
  SurveyClient,
  UserClient,
  VesselClient,
  LocationClient,
  AlarmConfigClient
} from '@/server/MakeSenseApp-backend'
import axios, { AxiosInstance } from 'axios'
import { getAccessToken } from '@/utilities/auth'
import { MSAL } from '../msal/msal'

export const clientsPlugin = {
  install: (app: any) => {
    const instance: AxiosInstance = axios.create()

    instance.interceptors.request.use(async (config) => {
      // Adding auth token header
      const msal: MSAL = app.config.globalProperties.$msal
      if (msal.isAuthenticated()) {
        const token = await getAccessToken(msal)
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } else {
        console.warn('Not authenticated with msal')
      }

      return config
    })

    app.provide('AlarmClient', new AlarmClient(undefined, instance))
    app.provide('CableClient', new CableClient(undefined, instance))
    app.provide('ConfigurationClient', new ConfigurationClient(undefined, instance))

    app.provide('DasClient', new DasClient(undefined, instance))
    app.provide('DoBClient', new DoBClient(undefined, instance))
    app.provide('DocumentationClient', new DocumentationClient(undefined, instance))

    app.provide('DtsClient', new DtsClient(undefined, instance))
    app.provide('HomeClient', new HomeClient(undefined, instance))
    app.provide('ProjectClient', new ProjectClient(undefined, instance))

    app.provide('OrganizationClient', new OrganizationClient(undefined, instance))
    app.provide('UserClient', new UserClient(undefined, instance))

    app.provide('RttrClient', new RttrClient(undefined, instance))
    app.provide('SparePartsClient', new SparePartsClient(undefined, instance))
    app.provide('SurveyClient', new SurveyClient(undefined, instance))
    app.provide('VesselClient', new VesselClient(undefined, instance))

    app.provide('LocationClient', new LocationClient(undefined, instance))

    app.provide('AlarmConfigClient', new AlarmConfigClient(undefined, instance))

    app.provide('AxiosInstance', instance)
  }
}
